import { Link } from 'react-router-dom';

const list = require("../data/data-bsnx-actions.json").data;

export default function BusinessActions() {

  return (
    <>
    <div className="card rounded-wd border border-top-0"
      style={{borderTopLeftRadius:'0', borderTopRightRadius:'0'}}>
      <div className="row row-cols-3 row-cols-md-6 g-0">
        {list && list.map((item, i) => ( item.actv ?
          <div className="col text-center py-2" key={i}>
            <Link className="btn px-0" to={item.link}>
              <i 
                className={`text-primary ${item.icon}`} 
                style={{fontSize:'2rem', lineHeight:'1rem'}}>
              </i>
              <p className="m-0 p-0 small">
                <small className="line-clamp-sm">{item.text}</small>
              </p>
            </Link>

          </div>
        :''))}
      </div>
    </div>


    </>
  )
}